import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EXTERNAL_API_LOAD_EXTERNAL_DATABASE_BEGIN,
  EXTERNAL_API_LOAD_EXTERNAL_DATABASE_SUCCESS,
  EXTERNAL_API_LOAD_EXTERNAL_DATABASE_FAILURE,
  EXTERNAL_API_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EXTERNAL_API_LOAD_EXTERNAL_DATABASE_BEGIN,
    });
    const { projectId, version } = args;
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb`;
      if (args.type) {
        url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb?type=${args.type}`;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_LOAD_EXTERNAL_DATABASE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_LOAD_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalDatabaseError() {
  return {
    type: EXTERNAL_API_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_LOAD_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        loadExternalDatabasePending: true,
        loadExternalDatabaseError: null,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        loadExternalDatabasePending: false,
        loadExternalDatabaseError: null,
        externalDatabase: action.data,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        loadExternalDatabasePending: false,
        loadExternalDatabaseError: action.data.error,
      };

    case EXTERNAL_API_LOAD_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
